module.exports = __webpack_public_path__ + "fonts/analogue-italic-webfont.9ef0dfe.woff";